class ToolTip extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['toggle']
  }

  setupListeners () {
    super.setupListeners()

    this.release = this.release.bind(this)

    this.listeners.add(
      this.els.toggle.element,
      'click',
      this.togglePressed.bind(this),
    )
  }

  togglePressed () {
    this.pressed = !this.pressed
  }

  release () {
    this.pressed = false
  }

  get pressed () {
    return this.getAttribute('aria-pressed') === 'true'
  }

  /** @param {boolean} pressed */
  set pressed (pressed) {
    this.setAttribute('aria-pressed', pressed)

    /**
     * Adding the listener immediately causes the setter to run
     * twice. `requestAnimationFrame` lets the original click
     * event finish bubbling to the document first
     */
    window.requestAnimationFrame(() => {
      if (pressed) {
        this.listeners.add(document, 'click', this.release)
      } else {
        this.listeners.remove('click', this.release)
      }
    })
  }
}

if (!window.customElements.get('tool-tip')) {
  window.customElements.define('tool-tip', ToolTip)
}
